import React from 'react';
import { useNavigate } from "react-router-dom";
import { process } from "@progress/kendo-data-query";
import useFetchWithMsal from '../services/useFetchWithMsal';
import { apiRoutes } from '../services/apiRoutes';
import { SiteData } from '../Data/SiteData';
import { DefaultTextData } from '../Data/DefaultTextData';
import { Layout } from '../components/MasterPage/Layout';
import { DefaultTextGrid } from '../components/Grid/DefaultTextGrid';
import { AddEditDefaultTextModal } from '../components/Modals/AddEditDefaultTextModal';
import { DeleteModal } from '../components/Modals/DeleteModal';
import { AssignToSiteModal } from '../components/Modals/AssignToSiteModal';
import { ContextMenu } from '../components/ContextMenu';

export function DefaultTextList(props) {
	let navigate = useNavigate();
	const { execute, result } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});
	const { getDefaultTextData, postDefaultText, deleteDefaultText, assignDefaultTextToSites } = DefaultTextData({ execute: execute, customer: props.customer });
	const { getSites } = SiteData({ execute: execute, customer: props.customer });
	
	const [success, setSuccess] = React.useState(false);
	const [error, setError] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [validationError, setValidationError] = React.useState(false);
	const [validationErrorMessage, setValidationErrorMessage] = React.useState("");

	const [sitesSelected, setsitesSelected] = React.useState([]);
	const [sites, setsites] = React.useState([]);
	const [CurrentDefaultTextValue, setCurrentDefaultTextValue] = React.useState("");
	const [localeSelected, setlocaleSelected] = React.useState(1033);
	const [downloadGrid, setdownloadGrid] = React.useState(false);
	const [showColumnSelect, setshowColumnSelect] = React.useState(false);
	const [buttonsConfig, setbuttonsConfig] = React.useState([]);
	const [localesDropdownData, setlocalesDropdownData] = React.useState([]);
	const [filteredLocales, setfilteredLocales] = React.useState([]);
	const [currentDefaultTextLocales, setcurrentDefaultTextLocales] = React.useState([]);
	const [currentDefaultTextId, setcurrentDefaultTextId] = React.useState(0);
	const [showDeleteDefaultTextModal, setshowDeleteDefaultTextModal] = React.useState(false);
	const [showAssignToSiteModal, setshowAssignToSiteModal] = React.useState(false);
	const [show, setshow] = React.useState(false);
	const [selectedDefaultText, setselectedDefaultText] = React.useState({});
	const [defaultTexts, setdefaultTexts] = React.useState([]);
	const [originaldefaultTexts, setoriginaldefaultTexts] = React.useState([]);
	const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
	const [pending, setPending] = React.useState(false);
	const [showContext, setshowContext] = React.useState(false);
	const [dataResult, setDataResult] = React.useState(process(originaldefaultTexts, dataState));
	const dataStateChange = (event) => {
		setDataResult(process(defaultTexts, event.dataState));
		setDataState(event.dataState);
	};

	const offSet = React.useRef({ left: 0, top: 0 });
	const defaultTextMenuClick = (DefaultTextId, e) => {
		setcurrentDefaultTextId(DefaultTextId);
		e.preventDefault();
		offSet.current = {
			left: e.clientX,
			top: e.clientY,
		};
		setshowContext(true);
	};

	const menuItems = [props.localizations.Delete, props.localizations.Edit, props.localizations.AssignToSite];
	const rowContextClick = (e) => {
		if (e.item.text === props.localizations.Delete)
			toggleDeleteDefaultTextModal();
		else if (e.item.text === props.localizations.Edit)
			toggleModal(currentDefaultTextId);
		else if (e.item.text === props.localizations.AssignToSite)
			toggleAssignDefaultTextToSite();
	};

	const getData = async () => {
		setPending(true);
		fetch(apiRoutes.documents.language.options, { method: "GET" }).then(
			(response) => {
				response.json().then((json) => {
					if (json != null) {
						for (var i = 0; i < json.length; i++) {
							json[i].label = (props.localizations[json[i].language] ?? json[i].language);
							json[i].value = json[i].localeId;
						}
						setlocalesDropdownData(json);
						setfilteredLocales(json);
					}
				});
			}
		);

		getSites().then((data) => {
			setsites(data);
		});

		let gridData = await getDefaultTextData();
		if (gridData != null) {
			setPending(false);
			setDataResult(process(gridData, { skip: 0, take: 25 }));
			setDataState({ skip: 0, take: 25 });
			setoriginaldefaultTexts(gridData);
			setdefaultTexts(gridData);
		}
	};

	const save = () => {

		setError(false);
		setValidationError(false);
		let nameUsed = false;
		defaultTexts.forEach(function (defaultText) { if (defaultText.defaultTextName === selectedDefaultText.defaultTextName && defaultText.defaultTextId !== selectedDefaultText.defaultTextId) nameUsed = true; }
		);

		if (!nameUsed && selectedDefaultText.defaultTextName && selectedDefaultText.defaultTextName != "") {
			setPending(true);
			postDefaultText(selectedDefaultText.defaultTextName, currentDefaultTextLocales, selectedDefaultText).then(async () => {
				setshow(!show);
				await getData();
				setSuccess(true);
				setTimeout(function () {
					setSuccess(false);
				}, 5000);
			})
				.catch((error) => {
					setError(true);
					setErrorMessage(props.localizations.RetrieveSiteError);
				});
		}
		else {
			setSuccess(false);
			setValidationError(true);
			if (nameUsed) { setValidationErrorMessage(props.localizations.DefaultTextUnique); } else { setValidationErrorMessage(props.localizations.Required); }
		}
	};

	const submitDeleteDefaultText = async () => {
		setPending(true);
		setshowDeleteDefaultTextModal(!showDeleteDefaultTextModal);
		deleteDefaultText(currentDefaultTextId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
			.catch((error) => {
				setError(true);
				setErrorMessage(props.localizations.RetrieveSiteError);
			});
	};

	const submitAssigndefaultTextsiteDefaultText = async () => {
		setPending(true);
		setshowAssignToSiteModal(!showAssignToSiteModal);
		await assignDefaultTextToSites(sitesSelected, currentDefaultTextId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
			.catch((error) => {
				setError(true);
				setErrorMessage(props.localizations.RetrieveSiteError);
			});
	};

	const handleLocalesDropdownChange = (e) => {
		setlocaleSelected(e.value);
		if (localeSelected != null) {
			let locale = currentDefaultTextLocales.find(x => x.localeId === localeSelected.localeId);
			let localeNew = currentDefaultTextLocales.find(x => x.localeId === e.value.localeId);
			if (locale != null)
				locale.defaultText = CurrentDefaultTextValue;

			setcurrentDefaultTextLocales(currentDefaultTextLocales);

			if (localeNew != null)
				setCurrentDefaultTextValue(localeNew.defaultText);
			else
				setCurrentDefaultTextValue("");
		}
		else {
			currentDefaultTextLocales.push({ localeId: e.value.localeId, defaultText: CurrentDefaultTextValue });
			setcurrentDefaultTextLocales(currentDefaultTextLocales);
		}
	};

	const handleSitesDropdownChange = (e) => {
		let newsites = sites;
		newsites.forEach(x => {
			x.show = false;
		});
		e.value.forEach(x => {
			let site = newsites.find(y => x.value === y.value);
			if (site)
				site.show = true;
		});

		let selecSites = e.value;
		setsitesSelected(selecSites);
		setsites(newsites);
	};

	const toggleDeleteDefaultTextModal = () => {
		setshowDeleteDefaultTextModal(!showDeleteDefaultTextModal);
	};

	const handleDefaultTextValueChange = (e) => {
		let language = localeSelected;
		if (language == null || language === 1033 || language.localeId == null) {
			language = localesDropdownData.find(x => x.localeId === 1033);
			setlocaleSelected(language);
		}
		setCurrentDefaultTextValue(e.html);
		let locale = currentDefaultTextLocales.find(x => x.localeId === language.localeId);

		if (locale == null) {
			currentDefaultTextLocales.push({ localeId: language.localeId, defaultText: e.html });
			setcurrentDefaultTextLocales(currentDefaultTextLocales);
		}
		else {
			locale.defaultText = e.html;
			setcurrentDefaultTextLocales(currentDefaultTextLocales);
		}
	}

	const toggleModal = (DefaultTextId) => {
		setshow(!show);
		if (show)
			return;

		if (DefaultTextId != null) {
			var defaultText = defaultTexts.find(x => x.defaultTextId === DefaultTextId);
			if (defaultText != null) {
				setcurrentDefaultTextLocales(defaultText.publicSiteDefaultTextLocales);
				var locale = localesDropdownData.find(x => x.localeId === defaultText.publicSiteDefaultTextLocales[0].localeId);

				setlocaleSelected(locale);
				setselectedDefaultText(defaultText);
				setCurrentDefaultTextValue(defaultText.publicSiteDefaultTextLocales[0].defaultText);
			}
		}
		else {
			setselectedDefaultText({ defaultTextName: "",  });
			setCurrentDefaultTextValue("");
			setcurrentDefaultTextLocales([]);
			let locale = props.languageValue;
			locale.label = locale.language;
			locale.value = locale.localeId;
			setlocaleSelected(locale);
		}
	};

	const toggleAssignDefaultTextToSite = () => {
		setshowAssignToSiteModal(!showAssignToSiteModal);
		let defaultText = originaldefaultTexts.filter(x => x.defaultTextId === currentDefaultTextId);
		let selected = sites.filter(x => defaultText.filter(y => y.defaultTextId === x.site.defaultTextId).length > 0);
		setsitesSelected(selected);
	};

	const [gotData, setgotData] = React.useState(false);
	React.useEffect(() => {
		if (gotData || result == null)
			return;
		setgotData(true);
	}, [execute]);

	React.useEffect(() => {
		if (props.currentTenent.CustomerId == null)
			return;
		if (!props.currentTenent.IsEditDefaultTextUser)
			navigate("/NoPermissions");
		if (gotData && execute != null)
			getData();
	}, [gotData, execute, props.currentTenent.CustomerId]);

	React.useEffect(() => {
		setbuttonsConfig([
			{
				type: 'primary',
				text: props.localizations.AddDefaultText,
				onClick: () => { toggleModal(); }
			},
			{
				type: 'secondary',
				icon: 'icon-ui-general-libraries',
				tooltip: props.localizations.Columns,
				position: "top",
				onClick: () => { setshowColumnSelect(true); }
			},
			{
				type: 'secondary',
				icon: 'icon-ui-general-download',
				tooltip: props.localizations.Download,
				position: "top",
				onClick: () => { setdownloadGrid(true); }
			}
		]);
	}, [props.localizations, execute]);

	return (
		<Layout versionNumber={props.versionNumber} success={success} setSuccess={setSuccess} error={error} setError={setError} errorMessage={errorMessage} setValidationError={setValidationError} validationErrorMessage={validationErrorMessage} buttonsConfig={buttonsConfig} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue} >
			<div>
				<DefaultTextGrid defaultTextMenuClick={defaultTextMenuClick} customer={props.customer} dateFormatId={props.customer.dateFormatId} localizations={props.localizations}
					pending={pending} defaultTexts={defaultTexts} dataState={dataState} dataResult={dataResult} dataStateChange={dataStateChange}
					showColumnSelect={showColumnSelect} downloadGrid={downloadGrid} setdownloadGrid={setdownloadGrid} setshowColumnSelect={setshowColumnSelect} />

				<ContextMenu menuItems={menuItems} offSet={offSet} rowContextClick={rowContextClick} showContext={showContext} setshowContext={setshowContext} />

				<AddEditDefaultTextModal localizations={props.localizations} selectedDefaultText={selectedDefaultText} setselectedDefaultText={setselectedDefaultText}
					show={show} toggleModal={toggleModal} save={save} handleLocalesDropdownChange={handleLocalesDropdownChange} localeSelected={localeSelected}
					localesDropdownData={localesDropdownData} validationError={validationError} validationErrorMessage={validationErrorMessage} CurrentDefaultTextValue={CurrentDefaultTextValue} handleDefaultTextValueChange={handleDefaultTextValueChange}
					filteredLocales={filteredLocales} setfilteredLocales={setfilteredLocales} />
				<DeleteModal localizations={props.localizations} DeleteConfirm={props.localizations.DeleteDefaultTextConfirm} showDeleteModal={showDeleteDefaultTextModal} toggleDeleteModal={toggleDeleteDefaultTextModal} submitDelete={submitDeleteDefaultText} />
				<AssignToSiteModal localizations={props.localizations} handleSitesDropdownChange={handleSitesDropdownChange} sites={sites} sitesSelected={sitesSelected} showAssignToSiteModal={showAssignToSiteModal} toggleAssignToSite={toggleAssignDefaultTextToSite} submitAssignSite={submitAssigndefaultTextsiteDefaultText } />
			</div>
		</Layout>
	);
}
